/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2022-04-18 11:19:09
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-27 17:36:28
 * @FilePath: /wemeet-admin-new/src/api/global.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 获取全部的事件列表
export function getAllEvent() {
  return request({
    url: '/cs/admin/event/eventList',
    method: 'get',
  })
}

// 获取全局配置
export function getGlobalConfig(keyword) {
  return request({
    url: `/user/ac/global/get?pageNo=1&pageSize=20&keyword=${keyword}`,
    method: 'GET',
  })
}
